import { IUser } from "../../types/User";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { useEffect, useState } from "react";
import { useLazyGetUserQuery } from "../../services/user";
import Icon from "../../components/Icon";
import ROUTES from "../../routes";
import ImamBasicInfo from "../Imam/ProfileSections/ImamBasicInfo";
import HrnModal from "../../components/HrnModal";
import { Form, Skeleton } from "antd";
import validateMessages from "../../utils/validate";
import ImamBasicInfoForm from "../Imam/ProfileForms/ImamBasicInfoForm";
import dayjs from "dayjs";
import { useUpdateMyProfileMutation } from "../../services/me";
import ChangePassword from "./ChangePassword";
import { useTranslation } from "react-i18next";

const MyProfile = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { loggedInUser } = useSelector((state: RootState) => state.global);
    const { section } = useParams();
    const [user, setUser] = useState<IUser | null>(null);
    const [open, setOpen] = useState(false);
    const [activeKey, setActiveKey] = useState("1");
    const [editForm] = Form.useForm();
    const [getUserTrigger, getUserResult] = useLazyGetUserQuery();

    useEffect(() => {
        try {
            if (loggedInUser?.id) {
                getUserTrigger({ id: loggedInUser.id });
            }
        } catch (e) { }
    }, [loggedInUser?.id]);

    useEffect(() => {
        if (open && user)
            editForm.setFieldsValue({
                ...user,
                gender: user.profileData?.gender,
                dateOfBirth: user.profileData?.dateOfBirth && dayjs(user.profileData.dateOfBirth)
            });
    }, [open, user]);

    useEffect(() => {
        if (getUserResult.isSuccess) {
            setUser(getUserResult.data?.data);
        }
    }, [getUserResult.isFetching])

    const onBack = () => {
        navigate(`${ROUTES.PATHS.PROFILE}`);
    };
    const onEdit = (activeKey: string) => {
        setActiveKey(activeKey)
        setOpen(true);
    };
    const hideModal = () => {
        setOpen(false);
    };

    const afterModalClose = () => {
        editForm.resetFields();
    };

    const [updateMyProfile, { isLoading: updating }] = useUpdateMyProfileMutation();
     const onSave = async () => {
        try {
            await editForm.validateFields();
        } catch (errorInfo) {
            return;
        }
        const formFields = editForm.getFieldsValue();

        if (activeKey === "1") {
            const payload = {
                ...formFields,
                dateOfBirth: formFields.dateOfBirth
                    ? dayjs(formFields.dateOfBirth).format()
                    : null,
            };
            try {
                await updateMyProfile({ body: payload });
                setOpen(false);
            } catch (e) { }
        } 
    };

    return (<>
        {getUserResult.isLoading ? <Skeleton active /> : <>
            {section === "basic" && <div className="basic-sec">
                <h2 className="mt-0 text-primary">
                    <Icon icon="arrow_back" className="h-5 w-5 cursor-pointer mr-1" onClick={onBack} />
                    <span>{t("Basic information")}</span>
                    <Icon icon="edit" className="h-5 w-5 cursor-pointer ml-5" onClick={() => onEdit("1")} />
                </h2>
                <ImamBasicInfo user={user! || {}} dataSources={[]} />
            </div>}            
            {section === "password" && <div className="password-sec">
                <h2 className="mt-0 text-primary">
                    <Icon icon="arrow_back" className="h-5 w-5 cursor-pointer mr-1" onClick={onBack} />
                    <span>{t("Account password")}</span>
                </h2>
                <ChangePassword />
            </div>}

            <HrnModal
                open={open}
                title={"Edit profile information"}
                width={520}
                isLoading={
                    (
                        updating
                    ) as boolean
                }
                submitButtonTitle={"Update"}
                onCancel={hideModal}
                onSave={onSave}
                afterClose={afterModalClose}
            >
                <div className="mt-6">
                    <Form
                        form={editForm}
                        layout="vertical"
                        name="editForm"
                        validateMessages={validateMessages}
                    >
                        {activeKey === "1" && <ImamBasicInfoForm editForm={editForm} user={user!} datasources={[]} />}
                    </Form>
                </div>
            </HrnModal>
        </>}
    </>);
};

export default MyProfile;
